export const PAYMENT_SLOTS = [
    { ordinal: "first", index: 1, label: "First Payment", invoiceLabel: "1ST PAYMENT:", depositField: null },
    { ordinal: "second", index: 2, label: "Second Payment", invoiceLabel: "2ND PAYMENT:", depositField: "secondDeposit", stepCode: "secondPayment" },
    { ordinal: "third", index: 3, label: "Third Payment", invoiceLabel: "3RD PAYMENT:", depositField: "thirdDeposit", stepCode: "thirdPayment" },
    { ordinal: "fourth", index: 4, label: "Fourth Payment", invoiceLabel: "4TH PAYMENT:", depositField: "fourthDeposit" },
    { ordinal: "fifth", index: 5, label: "Fifth Payment", invoiceLabel: "5TH PAYMENT:", depositField: null },
    { ordinal: "sixth", index: 6, label: "Sixth Payment", invoiceLabel: "6TH PAYMENT:", depositField: null },
    { ordinal: "seventh", index: 7, label: "Seventh Payment", invoiceLabel: "7TH PAYMENT:", depositField: null },
    { ordinal: "eighth", index: 8, label: "Eighth Payment", invoiceLabel: "8TH PAYMENT:", depositField: null },
    { ordinal: "ninth", index: 9, label: "Ninth Payment", invoiceLabel: "9TH PAYMENT:", depositField: null },
    { ordinal: "tenth", index: 10, label: "Tenth Payment", invoiceLabel: "10TH PAYMENT:", depositField: null },
];

export const paymentAmountField = (slot) => `${slot.ordinal}Payment`;

export const paymentReceiptField = (slot) => `${slot.ordinal}ReceiptNo`;

export const paymentReceiptType = (slot) => slot.label.replace(" ", "_");

export const ORDER_FORM_PAYMENTS = PAYMENT_SLOTS.filter(
    (slot) => slot.ordinal === "second" || slot.ordinal === "third"
).map((slot) => ({
    name: slot.depositField,
    label: `${slot.label} (Optional)`,
    placeholder: `${slot.label} Amount`,
    stepCode: slot.stepCode,
}));

export const RECEIPT_BUTTON_COLORS = [
    "#4CAF50",
    "#2196F3",
    "#FF9800",
    "#9C27B0",
    "#00796B",
    "#5C6BC0",
    "#EF6C00",
    "#6D4C41",
    "#00838F",
    "#C62828",
];
